import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom"; 

function Enquiry({ onClose }) {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const navigate = useNavigate(); 
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  async function enqsave(event) {
    event.preventDefault();

    if (!name || !email || !mobile || !message) {
      alert("Please fill all fields.");
      return;
    }

    const enquiryData = { name, email, phone: mobile, remarks: message };

    setLoading(true);

    try {
      const response = await fetch("https://api.prathamstyle.com/api/ContactUs", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(enquiryData),
      });

      if (!response.ok) {
        throw new Error(`Server error: ${response.status}`);
      }

      const result = await response.json();
      console.warn("Response:", result);
  

   
      setName("");
      setEmail("");
      setMobile("");
      setMessage("");

    
      if (onClose) onClose();


      navigate("/Thankyou");

    } catch (error) {
      console.error("Error submitting enquiry:", error);
      alert("Failed to submit enquiry. Please try again.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, ease: "easeOut" }}
    >
      <div className="popupOverlay">
        <div className="popupContent">
          <h2>Enquiry Form</h2>

          <form onSubmit={enqsave}>
            <label>Your Name:</label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Enter your name"
              required
            />

            <label>Your Email ID:</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              required
            />

            <label>Contact No:</label>
            <input
              type="text"
              value={mobile}
              onChange={(e) => setMobile(e.target.value)}
              placeholder="Enter your contact number"
              required
            />

            <label>Message:</label>
            <textarea
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder="Enter your enquiry"
              required
            ></textarea>

            <button type="submit" disabled={loading}>
            Submit
            </button>
          </form>
        </div>
      </div>
    </motion.div>
  );
}

export default Enquiry;
